import React from 'react';
import Drafts from './components/Drafts';

export default function Publications() {
  return (
    <Drafts />
  )
};
